import moment from 'moment'

export const buildAppointmentCalendarEvent = (appointment, options = {}) => {
	if (!appointment) return null

	const startRaw = appointment.fechaTurnoDateTime || appointment.fechaHora
	if (!startRaw) return null

	const startTime = moment(startRaw)
	if (!startTime.isValid()) return null

	const type = appointment.tipo || appointment.nombre || options.defaultType || 'Presencial'
	const professional = appointment.nombreProfesional || 'profesional'
	const clinic = appointment.clinica || appointment.direccion || 'clínica'
	const location = appointment.direccion || appointment.clinica || ''
	const durationHours = options.durationHours || 1

	return {
		title: `Turno - ${type}`,
		description: `Turno con ${professional} en ${clinic}.`,
		location,
		startTime,
		endTime: moment(startTime).add(durationHours, 'hours')
	}
}